import Input from "Components/UI/Input";
import { useFormattedProjectOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import React, { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import PropTypes from "prop-types";
import { Select } from "antd";

const ProjecController = ({ id, handleUpdateAttendance, projectsOptions }) => {
  const { setValue, watch } = useFormContext();

  const companyCode = useWatch({ name: "companyCode" });
  const projectCode = useWatch({ name: `attendance[${id}].projectCode` });

  // const projectsOptions = useFormattedProjectOption({ companyCode, });
  return (
    <div className="form-floating">
      <Select
        name={`attendance[${id}].projectCode`}
        showSearch
        options={projectsOptions}
        placeholder="Select Project"
        value={
          projectCode && projectCode !== ""
            ? { value: projectCode, label: watch(`attendance[${id}].projectName`) || "" }
            : undefined
        }
        size="large"
        style={{ width: "100%" }}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        allowClear
        labelInValue
        onSelect={(e) => {
          setValue(`attendance[${id}].projectCode`, e.value);
          setValue(`attendance[${id}].projectName`, e.label);
          handleUpdateAttendance(id);
        }}
        disabled={
          watch(`attendance[${id}].isApproved`) ||
          watch(`attendance[${id}].isReviewed`) ||
          watch(`attendance[${id}].inTime`) === "00:00:00" ||
          watch(`attendance[${id}].outTime`) === "00:00:00"
        }
        onClear={() => {
          setValue(`attendance[${id}].projectCode`, "");
          setValue(`attendance[${id}].projectName`, "");
          handleUpdateAttendance(id);
        }}
      />
    </div>
  );
  // return (
  //   <div className="form-floating">
  //      <Controller
  //           name={`attendance[${id}].shiftId`}
  //           control={control}
  //           render={({ field }) => (
  //     <Select
  //       // {...field}
  //       name={`attendance[${id}].projectCode`}
  //       showSearch
  //       options={projectsOptions}
  //       placeholder="Select Project"
  //       // value={field.value !== undefined && field.value !== "" ? field.value : undefined}defaultValue={{ label: shiftName || "" }}
  //       defaultValue={{ value: projectCode || ""}}
  //       size="large"
  //       style={{ width: "100%" }}
  //       filterOption={(input, option) =>
  //         option.label.toLowerCase().includes(input.toLowerCase())
  //       }
  //       allowClear
  //       labelInValue
  //       onSelect={(e) => {
  //         setValue(`attendance[${id}].projectCode`, e.value);
  //         setValue(`attendance[${id}].projectName`, e.label);
  //         handleUpdateAttendance(id);
  //       }}
  //       disabled={
  //         watch(`attendance[${id}].isApproved`) ||
  //         watch(`attendance[${id}].isReviewed`) ||
  //         watch(`attendance[${id}].inTime`) === "00:00:00" ||
  //         watch(`attendance[${id}].outTime`) === "00:00:00"
  //       }
  //       onClear={() => {
  //         setValue(`attendance[${id}].projectCode`, 0);
  //         setValue(`attendance[${id}].projectName`, "");
  //         handleUpdateAttendance(id);
  //       }}
  //     />
  //     {/* )}
  //         /> */}
  //   </div>
  //   // <Input
  //   //   name={`attendance[${id}].projectCode`}
  //   //   type="commonSelect"
  //   //   className="form-control select-option-height"
  //   //   // value={projectCode}
  //   //   value={{
  //   //     value: watch(`attendance[${id}].projectCode`) || "",
  //   //     label: watch(`attendance[${id}].projectName`) || "",
  //   //   }}
  //   //   optionData={projectsOptions}
  //   //   labelInValue
  //   //   placeholder="Select Project"
  //   //   onSelect={(e) => {
  //   //     setValue(`attendance[${id}].projectCode`, e.value);
  //   //     setValue(`attendance[${id}].projectName`, e.label);
  //   //     handleUpdateAttendance(id);
  //   //   }}
  //   //   disabled={
  //   //     watch(`attendance[${id}].isApproved`) ||
  //   //     watch(`attendance[${id}].isReviewed`) ||
  //   //     watch(`attendance[${id}].inTime`) === "00:00:00" ||
  //   //     watch(`attendance[${id}].outTime`) === "00:00:00"
  //   //   }
  //   //   style={{ width: "150px" }}
  //   //   allowClear={true}
  //   //   onClear={() => {
  //   //     setValue(`attendance[${id}].projectCode`, 0);
  //   //     setValue(`attendance[${id}].projectName`, "");
  //   //     handleUpdateAttendance(id);
  //   //   }}
  //   // />
  // );
};

export default React.memo(ProjecController);

ProjecController.propTypes = {
  projectsOptions: PropTypes.array.isRequired,
  handleUpdateAttendance: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};
// This component is a controller for selecting a project in an attendance form.
// It uses a select input to allow users to choose a project based on the company code.
